/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { FaSearch } from 'react-icons/fa';
import ScriptLoader from 'react-script-loader-hoc';
import Button from '../../components/button';
import H1 from '../../components/h1';
import Spacer from '../../components/spacer';
import BackButton from '../../components/backButton';
import Select from '../../components/select';
import Input from '../../components/input';
import ButtonLink from '../../components/buttonLink';
import AppState from '../../store/appstate';
import { saveUserMeta } from '../../api/mutations';
import { getMyAccounts, getUserMeta } from '../../api/queries';
import ApiErrorMessage from '../../components/apiErrorMessage';
import countries from '../../data/countries';

function Onboarding2({ scriptsLoadedSuccessfully }) {
  const { t } = useTranslation(['onboarding', 'other', 'countries']);
  const history = useHistory();
  const [apiError, setApiError] = useState('');
  const [pending, setPending] = useState(false);
  const userMeta = getUserMeta();

  const myAccounts = getMyAccounts();
  const noAccounts = myAccounts.isSuccess && myAccounts.data === null;

  const migratedUser = userMeta.isSuccess && userMeta.data === null && !noAccounts;

  const saveUserMetaMutation = saveUserMeta();

  let service = null;
  let sessionToken = null;
  let geocoder = null;

  if (scriptsLoadedSuccessfully) {
    service = new google.maps.places.AutocompleteService();
    sessionToken = new google.maps.places.AutocompleteSessionToken();
    geocoder = new google.maps.Geocoder();
  }

  const onboarding = AppState.useState((s) => s.onboarding);

  let addressItems = [];

  const [showAddressArea, setShowAddressArea] = useState(false);

  const getAddressDetails = (add, addItems) => {
    const addressItem = addItems.find((a) => a.description === add);

    geocoder.geocode({ placeId: addressItem.place_id }, (place) => {
      const streetNumber = place[0].address_components.find((c) => c.types.includes('street_number'));
      const route = place[0].address_components.find((c) => c.types.includes('route'));
      const town = place[0].address_components.find(
        (c) => c.types.includes('postal_town') || c.types.includes('locality'),
      );
      let county = place[0].address_components.find((c) => c.types.includes('administrative_area_level_2'));
      if (onboarding.country === 'US') {
        county = place[0].address_components.find((c) => c.types.includes('administrative_area_level_1'));
      }

      const postcode = place[0].address_components.find((c) => c.types.includes('postal_code'));
      const country = place[0].address_components.find((c) => c.types.includes('country'));

      const obj = {
        address1: `${streetNumber ? streetNumber.long_name : ''}  ${route ? route.long_name : ''}`.trim(),
        address2: null,
        town: town ? town.long_name : null,
        county: county ? county.long_name : null,
        postcode: postcode ? postcode.long_name : null,
        country: country ? country.short_name : null,
      };

      AppState.update((s) => {
        s.onboarding.address1 = obj.address1;
        s.onboarding.address2 = obj.address2;
        s.onboarding.town = obj.town;
        s.onboarding.county = obj.county;
        s.onboarding.postcode = obj.postcode;
        s.onboarding.country = obj.country;
      });

      setShowAddressArea(true);
    });
  };

  const updateAddress = (value, part) => {
    const ad = JSON.parse(JSON.stringify(onboarding));
    ad[part] = value;
    AppState.update((s) => {
      s.onboarding = ad;
    });
  };

  const saveUser = async () => {
    setApiError('');
    setPending(true);
    const data = onboarding;

    saveUserMetaMutation.reset();

    saveUserMetaMutation.mutate(data, {
      onSuccess: () => {
        userMeta.refetch();
        setTimeout(() => {
          history.push('/');
          setPending(false);
        }, 2000);
      },
      onError: (error) => {
        setApiError(`${error}`);
        setPending(false);
      },
    });
  };

  return (
    <div className="container mx-auto">
      <div className="flex flex-col justify-center items-center text-white p-4 text-center min-h-screen-minus-footer">
        <H1>{t('onboarding:location-header')}</H1>
        <Spacer />
        <Select
          className="w-full lg:w-1/3  text-sentric-dark-gray"
          name="country"
          placeholder={t('other:select-country-placeholder')}
          value={onboarding.country}
          onChange={(selected) => {
            AppState.update((s) => {
              s.onboarding.country = selected;
            });
          }}
          options={countries.map((option) => ({
            name: t(`countries:${option.name}`),
            value: option.value,
          }))}
          search
        />
        {onboarding.country !== null && (
          <div className="w-full lg:w-1/3">
            <Spacer />
            <div className="w-full flex flex-row items-start justify-center">
              <SelectSearch
                options={[]}
                onChange={(add) => {
                  getAddressDetails(add, addressItems);
                }}
                className="select-search select-search--multiple text-sentric-dark-gray"
                search
                filterOptions={fuzzySearch}
                placeholder={t('onboarding:first-line-address')}
                getOptions={(query) => new Promise((resolve) => {
                  if (!query) {
                    resolve([]);
                    return;
                  }
                  service.getPlacePredictions(
                    {
                      componentRestrictions: {
                        country: onboarding.country,
                      },
                      // types: ['address', 'establishment'],
                      strictBounds: false,
                      input: query,
                      sessionToken,
                    },
                    (items, status) => {
                      // eslint-disable-next-line no-console
                      if (
                        status !== google.maps.places.PlacesServiceStatus.OK
                      ) {
                        // reject(status);
                        return;
                      }
                      if (items === null || items.length === 0) {
                        resolve([]);
                        return;
                      }

                      addressItems = items.filter(
                        (a) => a.types.includes('street_address')
                          || a.types.includes('establishment'),
                      );

                      resolve(
                        addressItems.map((item) => ({
                          value: item.description,
                          name: item.description,
                        })),
                      );
                    },
                  );
                })}
              />
              <div className="text-white text-xl ml-4 bg-sentric-dark-gray rounded-full p-4 -mt-1">
                <FaSearch />
              </div>
            </div>
            {!showAddressArea && !onboarding.address1 && (
              <>
                <Spacer thin />
                <ButtonLink
                  className="text-white underline focus:outline-none"
                  onClick={() => setShowAddressArea(true)}
                >
                  {t('onboarding:enter-address-manually')}
                </ButtonLink>
              </>
            )}
            {(showAddressArea || onboarding.address1) && (
              <>
                <Spacer />
                <Spacer />
                <Input
                  label="Address 1"
                  placeholder={t('onboarding:address-placeholder1')}
                  value={onboarding.address1}
                  onChange={(e) => updateAddress(e.target.value, 'address1')}
                />
                <Spacer thin />
                <Input
                  label="Address 2"
                  placeholder={t('onboarding:address-placeholder2')}
                  value={onboarding.address2}
                  onChange={(e) => updateAddress(e.target.value, 'address2')}
                />
                <Spacer thin />
                <Input
                  label="Town"
                  placeholder={t('onboarding:town-placeholder')}
                  value={onboarding.town}
                  onChange={(e) => updateAddress(e.target.value, 'town')}
                />
                <Spacer thin />
                <Input
                  label="County"
                  placeholder={t('onboarding:county-placeholder')}
                  value={onboarding.county}
                  onChange={(e) => updateAddress(e.target.value, 'county')}
                />
                <Spacer thin />
                <Input
                  label="Postcode"
                  placeholder={t('onboarding:postcode-placeholder')}
                  value={onboarding.postcode}
                  onChange={(e) => updateAddress(e.target.value, 'postcode')}
                />
              </>
            )}
          </div>
        )}
        <Spacer />
        <ApiErrorMessage apiError={apiError} />

        <div className="flex flex-row">
          <BackButton onClick={() => history.goBack()}>{t('onboarding:back-button')}</BackButton>
          <Button
            pending={pending}
            disabled={!onboarding.address1 || pending}
            onClick={() => {
              if (migratedUser) {
                saveUser();
              } else {
                history.push('/onboarding-3');
              }
            }}
          >
            {t('onboarding:next-step-button')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ScriptLoader(
  'https://maps.google.com/maps/api/js?libraries=places&key=AIzaSyBxO6c270Mh4JPSCijKoZwJ1oQEHkRHH9A',
)(Onboarding2);
